import { getLocationParams } from '@core/js/utils/url.util';
import { dispatcher } from 'dispatcher';
import { useCallback, useMemo } from 'react';
import { useNavigate } from '@core/js/hooks/navigate';
import { useDepositCounter } from '../useDepositCounter';
import { useTranslations } from '@core/js/hooks/i18n';
import { showCommonPopupAction } from '@core/js/components/common/popups/CommonPopup';
import { useDispatch } from 'react-redux';

export const useCheckUrlAfterDeposit = () => {
    const params = useMemo(() => getLocationParams(location.search), []);
    const { status, initiator, action } = params;
    const namesOfParams = useMemo(() => Object.keys(params), [params]);
    const navigate = useNavigate();
    const runDepositCounter = useDepositCounter();
    const t = useTranslations();
    const dispatch = useDispatch();

    return useCallback(() => {
        const isApp = window.document.getElementById('application');

        if (action === 'deposit' && status === 'success') {
            dispatcher.dispatch('deposit:success', params);
            runDepositCounter(params).then(() => navigate(window.location.pathname,
                undefined,
                { removeParams: namesOfParams }));
        }

        if (initiator === 'CASHIER_QD' && status === 'error') {
            dispatcher.dispatch('deposit:fail', params);
            isApp && isApp?.classList?.add('quick');
            dispatcher.dispatch('quickDeposit:show');
            dispatch(showCommonPopupAction({
                title: t('playtech.mobile.system.mobile-cashier.deposit.title'),
                content: t('playtech.mobile.system.mobile-cashier.transaction.error')
            }));
            navigate(window.location.pathname,
                undefined,
                { removeParams: namesOfParams });
        }
    }, [action, status, initiator, params, runDepositCounter, navigate, namesOfParams, dispatch, t]);
};
